import { put, select, call, fork, takeLatest, all } from "redux-saga/effects";
import { roles } from "../../configs/constants";
import { mediasApiUpsellProvider, sectorsApiUpsellProvider } from "../../lib/api/providers";
import { fetchMediasApi } from "../../pages/activite/phototheque/api";

import {
  PHOTOTHEQUE_FILTERS_LOADING,
  PHOTOTHEQUE_SET_MEDIAS,
  PHOTOTHEQUE_SET_CURRENT_FILTERS,
  PHOTOTHEQUE_MEDIAS_LOADING,
  PHOTOTHEQUE_SET_FILTERS,
  PHOTOTHEQUE_SET_PAGINATION,
  PHOTOTHEQUE_GET_DYNAMIQUE_FILTER_VALUES,
  PHOTOTHEQUE_SET_KEY_FILTER_SELECTED,
  PHOTOTHEQUE_SET_EMAILS_OF_MY_USERS
} from "../types";
import { getFiltersValuesApi } from "./functionsApi";
import hacks from "../../configs/hacks";

const getPhotothequeState = state => state.phototheque;
const getAuthSate = state => state.auth;
const getState = state => state;
const getCurrentClientState = state => state.currentClient || {};
const getUserInfosState = state => state.userInfos || {};
const getUsersFromSectorsApi = (token, clientId, currentUser) => {
  if (!clientId) clientId = 1;

  return sectorsApiUpsellProvider
    .post(
      "/",
      {
        match: { client_id: clientId },
        project: { users: 1 }
      },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      let listEmailUsers = response.data
        .map(sector => sector.users)
        .flat()
        .filter(user => (user.role_id > currentUser.role_id || user.email === currentUser.email) && user.role_id !== 5)
        .map(user => user.email)
        .sort();
      //if (currentUser.role_id === 1)
      listEmailUsers = response.data
        .map(sector => sector.users)
        .flat()
        .filter(user => user.role_id !== 5)
        .sort((a, b) => (a.email > b.email ? 1 : -1));
      return [...new Set(listEmailUsers.map(user => user.email))];
    });
};

const getMediasApi = async ({ state, emailsOfMyUsers, token }) => {
  const userInfos = getUserInfosState(state);
  const currentClient = getCurrentClientState(state);
  const { currentFilters, page, pageSize } = state.phototheque;
  let body = {
    match: {
      ...currentFilters,
      client_id: state.currentClient.id
    },
    sort: currentFilters.sort ? currentFilters.sort : { visit_start_date: -1 },
    page: page > 0 ? page : 1,
    pageSize: pageSize
  };
  if (!currentFilters.user_email && userInfos.role_id !== roles.CLIENT) {
    body.match = {
      ...body.match,
      user_email: { $in: emailsOfMyUsers }
    };
  }

  //ECOSYSTEM
  if (userInfos.email === "corepile@upsell.fr") {
    body.match = {
      ...body.match,
      "salepoint.eo_piles": ["COREPILE", "SCRELEC; COREPILE"]
    };
  }

  if (userInfos.email === "screlec@upsell.fr") {
    body.match = {
      ...body.match,
      "salepoint.eo_piles": ["SCRELEC", "SCRELEC; COREPILE"]
    };
  }

  //GSK PHARMA + ECOSYSTEM
  if (userInfos.role_id === roles.CLIENT && userInfos.email !== "gskpharma@upsell.fr" && currentClient.id !== 3) {
    body.match = {
      ...body.match,
      best: true
    };
  }

  //hack
  const hacksInstance = hacks(userInfos, currentClient.id);
  if (!hacksInstance.gallery.removeSectorLimitationToTerrain && userInfos.role_id === roles.TERRAIN) {
    body.match = {
      ...body.match,
      "sector.sector_id": userInfos.sectors.map(sector => sector.sector_id)
    };
  }

  if (hacksInstance.gallery.selfContentOnlyToTerrain && userInfos.role_id === roles.TERRAIN) {
    body.match = {
      ...body.match,
      user_email: userInfos.email
    };
  }

  body.match["media.response"] = { $exists: true };
  const medias = await fetchMediasApi({ token, body });
  return medias;
};

function* getDynFilterValues() {
  try {
    yield put({ type: PHOTOTHEQUE_FILTERS_LOADING, loading: true });
    const state = yield select(getPhotothequeState);
    const stateCurrentClient = yield select(getCurrentClientState);
    const userInfos = yield select(getUserInfosState);
    const params = {
      state: state,
      apiUrl: mediasApiUpsellProvider,
      startDateLabel: "visit_start_date",
      endDateLabel: "visit_end_date",
      emailsOfMyUsers: state.emailsOfMyUsers,
      clientId: stateCurrentClient.id,
      userInfos: userInfos
    };
    const values = yield call(getFiltersValuesApi, params);
    if (values.length <= 0) {
      throw new Error("No filters");
    }
    yield put({
      type: PHOTOTHEQUE_SET_FILTERS,
      values: values,
      key: state.keyFilterSelected
    });
    yield put({ type: PHOTOTHEQUE_FILTERS_LOADING, loading: false });
  } catch (e) {
    console.log("[NO DATA]", e.message);
    yield put({ type: PHOTOTHEQUE_FILTERS_LOADING, loading: false });
  }
}

function* getMedias() {
  try {
    yield put({ type: PHOTOTHEQUE_MEDIAS_LOADING, loading: true });
    const state = yield select(getState);
    const stateAuth = yield select(getAuthSate);
    const stateCurrentClient = yield select(getCurrentClientState);
    const stateUserInfos = yield select(getUserInfosState);
    const statePhoto = yield select(getPhotothequeState);
    let emailsOfMyUsers = statePhoto.emailsOfMyUsers;
    if (!emailsOfMyUsers) {
      emailsOfMyUsers = yield call(getUsersFromSectorsApi, stateAuth.token, stateCurrentClient.id, stateUserInfos);
      yield put({ type: PHOTOTHEQUE_SET_EMAILS_OF_MY_USERS, payload: emailsOfMyUsers });
    }

    let data = yield call(getMediasApi, { state, emailsOfMyUsers, token: stateAuth.token });
    if (!Array.isArray(data.docs)) {
      throw new Error("No pictures");
    }

    yield put({ type: PHOTOTHEQUE_SET_MEDIAS, payload: data });
    yield put({ type: PHOTOTHEQUE_MEDIAS_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: PHOTOTHEQUE_MEDIAS_LOADING, loading: false });
  }
}

function* watchFetchMedias() {
  yield takeLatest(PHOTOTHEQUE_SET_CURRENT_FILTERS, getMedias);
}

function* watchFetchMediasPagination() {
  yield takeLatest(PHOTOTHEQUE_SET_PAGINATION, getMedias);
}

function* wathFetchDynFilterValues() {
  yield takeLatest(PHOTOTHEQUE_GET_DYNAMIQUE_FILTER_VALUES, getDynFilterValues);
}

function* watchSetKeyFilterSelected() {
  yield takeLatest(PHOTOTHEQUE_SET_KEY_FILTER_SELECTED, getDynFilterValues);
}

export default function* root() {
  yield all([
    fork(watchFetchMedias),
    fork(watchFetchMediasPagination),
    fork(wathFetchDynFilterValues),
    fork(watchSetKeyFilterSelected)
  ]);
}



// WEBPACK FOOTER //
// src/redux/sagas/photothequeSagas.js